import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  DiversionsPreviousRequestsSelectors,
  fromDiversionsPreviousRequests
} from '@ruby/modules/diversions/store/diversions-previous-requests.index';
import { IDiversionsPreviousRequest, IDiversionsPrevReqPayload } from '@ruby/shared/models/diversions/diversions.interface';

@Component({
  selector: 'ng-previous-requests-container',
  templateUrl: './previous-requests.container.html',
  styleUrls: ['./previous-requests.container.scss']
})
export class PreviousRequestContainer {
  store$: Observable<fromDiversionsPreviousRequests.State>;
  requests: Array<IDiversionsPreviousRequest> = [];
  previousRequest?: Partial<IDiversionsPrevReqPayload> = {};

  constructor(private store: Store<fromDiversionsPreviousRequests.State>) {
    this.store$ = this.store.select(DiversionsPreviousRequestsSelectors.selectDiversionsPrevRequestsState).pipe(tap((st: fromDiversionsPreviousRequests.State) => {
      if (st.previousRequest && JSON.stringify(this.previousRequest) !== JSON.stringify(st.previousRequest)) {
        this.previousRequest = st.previousRequest;
        this.requests = st.requests;
      }
    }));
  }
}
